module.exports = __webpack_public_path__ + "img/ViperRoomPromo1.bae8d47a.png";